import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { connect } from 'react-redux';
import HTTPStatus from 'http-status';

import {
    fetchUsuariDonarDeBaixa
} from '../../commons/consultesServidor';

import {
    crearNotificacioSuccess,
    crearNotificacioWarning
} from '../../commons/notificacio';

import {
    errorConsultaServidor
} from '../../actions/error';

import {
    usuariIntroduccioOmplirDades
} from '../../actions/usuari';

import {
    RETARD_MILISEGONS_APARICIO_SPINNER
} from '../../constants';

const missatgeExitDonarDeBaixa = 'Usuari donat de baixa correctament';
const missatgeErrorDonarDeBaixa = 'Error donant de baixa l\'usuari';
const missatgeAdvertenciaBaixaUsuari = {
    titol: missatgeExitDonarDeBaixa,
    descripcio: 'La informació que apareix no està actualitzada.'
};

class UsuariDetallDonarDeBaixa extends Component {

    constructor(props) {
        super(props);
        this.state = { modalVisible: false, peticioEnCurs: false };
        this.mostrarModal = this.mostrarModal.bind(this);
        this.amagarModal = this.amagarModal.bind(this);
        this.onClickOk = this.onClickOk.bind(this);
    }

    onClickOk() {
        this.setState({...this.state, peticioEnCurs: true});
        const { idUsuari } = this.props;
        return fetchUsuariDonarDeBaixa(idUsuari)
            .then(
                (resposta) => {
                    const { body, status} = resposta;

                    this.setState({modalVisible: false, peticioEnCurs: false});

                    if (status === HTTPStatus.PARTIAL_CONTENT) {
                        crearNotificacioWarning(
                            missatgeAdvertenciaBaixaUsuari.titol,
                            missatgeAdvertenciaBaixaUsuari.descripcio
                        );
                        return;
                    }

                    const { esActiu, estacions, dades } = body;
                    this.props.usuariIntroduccioOmplirDades(idUsuari, dades, estacions, esActiu);
                    crearNotificacioSuccess(missatgeExitDonarDeBaixa);
                },
                (errorServidor) => {
                    this.setState({modalVisible: true, peticioEnCurs: false});
                    this.props.errorConsultaServidor(errorServidor, missatgeErrorDonarDeBaixa);
                }
            );
    }

    mostrarModal() {
        this.setState({...this.state, modalVisible: true});
    }

    amagarModal() {
        this.setState({...this.state, modalVisible: false});
    }

    render() {

        const { modalVisible, peticioEnCurs } = this.state;
        const loadingBotoOK = peticioEnCurs ? {delay: RETARD_MILISEGONS_APARICIO_SPINNER} : false;

        return (
            <div>
                <Button size='large' type="primary" onClick={this.mostrarModal}>
                    Donar de baixa
                </Button>
                <Modal
                    visible={modalVisible}
                    title='Donar de baixa'
                    closable={false}
                    footer={[
                        <Button key="ok" type="primary" loading={loadingBotoOK} onClick={this.onClickOk}>OK</Button>,
                        <Button key="cancel" disabled={peticioEnCurs} onClick={this.amagarModal}>Cancel·lar</Button>,
                    ]}
                >
                    <p>{'Es donarà de baixa l\'usuari. També es donarà de baixa de les estacions.'}</p>
                    <p>{'Voleu continuar?'}</p>
                </Modal>
            </div>
        );
    }

}

UsuariDetallDonarDeBaixa.propTypes = {
    idUsuari: PropTypes.number,
    usuariIntroduccioOmplirDades: PropTypes.func,
    errorConsultaServidor: PropTypes.func
};

const mapDispatchToProps = {
    usuariIntroduccioOmplirDades,
    errorConsultaServidor
};

export default connect(null, mapDispatchToProps)(UsuariDetallDonarDeBaixa);



// WEBPACK FOOTER //
// ./src/components/usuari/usuariDetallDonarDeBaixa.js